import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/business_login.png")